<template>
    <a-form layout="inline" :form="form" class="myform" @keyup.enter.native="handleSubmit">
        <a-form-item label="关键字">
            <a-input v-model="searchP.keyword" placeholder="关键字(标题模糊,消息ID)"></a-input>
        </a-form-item>
        <a-form-item label="业务类型">
            <messageServiceSelecter :showAll="true" :channelcode="searchP.channelcode" @onmessageserviceCodeChange="handleMessageServiceChange"></messageServiceSelecter>
        </a-form-item>

        <a-form-item label="平台编码">
            <!-- <platformSelecter v-model="searchP.platformtype" :showAll="true" :isdisable="false"></platformSelecter> -->
            <a-input v-model="searchP.platformcode" placeholder="输入平台编码"></a-input>
        </a-form-item>

        <a-form-item label="发送时间">
            <a-range-picker ref="cTimeRange"
            :show-time="{
                        hideDisabledOptions: true,
                        format:'HH:mm'
                    }" :format="dateFormat"
            v-model="timeRange"
            @change="onChange" />
        </a-form-item>

        <a-form-item>
            <a-button type="primary" @click="handleSubmit">查询</a-button>
        </a-form-item>
    </a-form>
</template>

<script>
import moment from 'moment';
import messageServiceSelecter from '../../components/messageServiceSelecter'
// import platformSelecter from '../../components/platformSelecter'
export default {
    components:{
        messageServiceSelecter,
        // platformSelecter
    },
    data(){
        return {
            form: this.$form.createForm(this),
            timeRange:undefined,
            dateFormat:"YYYY-MM-DD HH:mm",
            searchP:{
                keyword:'',
                messageservicecode:'',
                channelcode:'',
                platformcode:'',
                messageid:'',
                starttime:'',
                endtime:'',
            }
        }
    },
    methods:{
        onChange(v,t){
            this.searchP.starttime = t[0];
            this.searchP.endtime = t[1]
        },
        handleMessageServiceChange(msg){
            this.searchP.messageservicecode = msg.messageservicecode
        },

        handleSubmit(sp){
            this.searchP.channelcode = sp.channelcode
            this.$emit("handleSearch",this.searchP);
        },

    },
    mounted(){
        const {query} = this.$route;
        if(query.messageid){
            this.searchP.messageid = query.messageid
        }

        let result = this.G.getRecentDate(13);
        let sTime = result.start_time;
        let eTime = result.end_time;
        this.timeRange = [moment(sTime, this.dateFormat), moment(eTime, this.dateFormat)]
        this.searchP.starttime = sTime;
        this.searchP.endtime = eTime
    }
}

</script>

<style>
    .myform{
        margin-bottom: 20px;
    }
</style>

